import React, { useEffect, useState } from 'react';
import "../../assets/css/ganttchart.css";
import { Box, Modal, Typography } from '@mui/material';
import { Button, Col, Row } from 'reactstrap';
import Select from '../Template/Input/Select';
import { getProductsFromOikosToGrid as getProductsToGrid, selectValues } from '../../utils/fc/index'
import Legenda from '../Legenda/Legenda';

// Esse gráfico de Gantt deve receber como parâmetro rows um array do que deve ser observado nas linhas do gráfico.

const GridProductsCalendar = ( { rows } ) => {

  const [ isModalOpen, setIsModalOpen ] = useState(false);
  const [ filterEntrega, setFilterEntrega ] = useState('entrega-interna-contratual');
  const [ productInfo, setProductInfo] = useState({});
  const [ selectedProj, setSelectedProj] = useState(null);
  const [ selectedCoord, setSelectedCoord] = useState(null);
  const [ products, setProducts] = useState(rows);
  const [ selectFilterTecnicoOptions, setSelectFilterTecnicoOptions ] = useState([]);
  const [ selectFilterProjetoOptions, setSelectFilterProjetoOptions ] = useState([]);
  const [ objectToConsultProductsInSQL, setObjectToConsultProductsInSQL ] = useState(null)
  const [ filteredProducts, setFilteredProducts ] = useState(null)

  // Helper function to extract day and month from date string
  const getDateParts = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return {
      month: `${year}-${month}`,
      day: parseInt(day, 10) // Convert to number and remove leading zeros
    };
  };

  const filterArray = (array, key, value) => {
    const filteredArray = array.filter((item) => item[key] === value);
    return filteredArray;
  }

  const getArrayMonthsYears = () => {
    document.getElementById('generateMonths').addEventListener('click', () => {
      const minDateInput = document.getElementById('minDate').value;
      const maxDateInput = document.getElementById('maxDate').value;

      if (!minDateInput || !maxDateInput) {
        console.error('Both minimum and maximum dates must be provided.');
        return;
      }

      const minDate = new Date(`${minDateInput}-01T00:00:00-03:00`);
      const maxDate = new Date(`${maxDateInput}-01T00:00:00-03:00`);

      if (minDate > maxDate) {
        console.error('Minimum date cannot be greater than maximum date.');
        return;
      }

      const monthsObject = {};
      let currentDate = new Date(minDate);

      while (currentDate <= maxDate) {
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const key = `${year}-${month}`;

        // Get the number of days in the current month
        const daysInMonth = new Date(year, currentDate.getMonth() + 1, 0).getDate();

        // Create an array of days
        monthsObject[key] = Array.from({ length: daysInMonth }, (_, i) => i + 1);

        // Move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      setObjectToConsultProductsInSQL(monthsObject);
    });
  }

  const getGanttData = () => {
    const arrayOfDaysToConsultInSQL = getArrayOfDaysToConsultInSQL(objectToConsultProductsInSQL);
    getProducts(arrayOfDaysToConsultInSQL);
  }

  const updateRows = (newRows) => {
    setFilteredProducts(newRows)
  }

  const getProducts = async (arrayOfDaysToConsultInSQL) => {
    const productsFromOikos = await getProductsToGrid(arrayOfDaysToConsultInSQL)
    setProducts(productsFromOikos)
    if (selectedCoord && selectedProj) {
      const [respId, projId] = [filteredProducts[0].prod_responsavel, filteredProducts[0].proj_id];
      setFilteredProducts(productsFromOikos.filter(product => product.prod_responsavel === respId && product.proj_id === projId));
    }
    else if (selectedCoord && !selectedProj) {
      const respId = filteredProducts[0].prod_responsavel;
      setFilteredProducts(productsFromOikos.filter(product => product.prod_responsavel === respId));
    }
    else if (selectedProj && !selectedCoord) {
      const projId = filteredProducts[0].proj_id;
      setFilteredProducts(productsFromOikos.filter(product => product.proj_id === projId));
    }
  }

  const getArrayOfDaysToConsultInSQL = (obj) => {
    const arrayDaysToConsultInSQL = [];
    Object.keys(obj).forEach(key => {
      obj[key].forEach(
        day => {
          arrayDaysToConsultInSQL.push(`${key}-${day <= 9 ? `0${day}` : `${day}`}`);
        }
      )
    });

    return arrayDaysToConsultInSQL;
  }

  const getSelectOptions = async () => {
    const selectTecnicoOptions = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {dpto_id: 4, pf_ativo: 1},
      {
        "(SELECT projAtuacao_id FROM projEquipe AS p WHERE pf.pf_id = p.pf_id AND projAtuacao_id = 8 LIMIT 1)" : "projAtuacao_id_coordenador_int",
        "(SELECT projAtuacao_id FROM projEquipe AS p WHERE pf.pf_id = p.pf_id AND projAtuacao_id = 7 LIMIT 1)" : "projAtuacao_id_coordenador_geral",
      });
    const selectProjetoOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1, projSituacao_id: 2},
      {"(SELECT proj_coord FROM proj AS p WHERE proj.proj_coord = p.proj_coord LIMIT 1)" : "proj_coord"});
    const selectTecnicoCoordOptions = selectTecnicoOptions.filter(option => (option.projAtuacao_id_coordenador_int || option.projAtuacao_id_coordenador_geral));
    setSelectFilterTecnicoOptions(selectTecnicoCoordOptions);
    setSelectFilterProjetoOptions(selectProjetoOptions);
  }

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  useEffect(()=>{
    if (!objectToConsultProductsInSQL) {
      const monthsObject = {};
      let currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const key = `${year}-${month}`;

      // Get the number of days in the current month
      const daysInMonth = new Date(year, currentDate.getMonth() + 1, 0).getDate();

      // Create an array of days
      monthsObject[key] = Array.from({ length: daysInMonth }, (_, i) => i + 1);

      // Move to the next month
      console.log(monthsObject)
      setObjectToConsultProductsInSQL(monthsObject);
    }
    getSelectOptions();
  }, [])

  useEffect(()=>{
    if(objectToConsultProductsInSQL) {
      getGanttData();
    }
  }, [objectToConsultProductsInSQL])

  if (objectToConsultProductsInSQL) {
    return (
      <>
        <div>
          <label for="minDate" className='mr-2'>Data Mínima:</label>
          <input type="month" className='mr-4' id="minDate"/>

          <label for="maxDate" className='mr-2'>Data Máxima:</label>
          <input type="month" id="maxDate"/>

          <Button size='sm' className='ml-4' id="generateMonths" onClick={(e) => {e.preventDefault();getArrayMonthsYears();}}>Buscar Produtos</Button>
          <div className='d-flex mt-4' style={{maxWidth: "100%"}}>
            <Col>
            <label>Coordenador:</label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectFilterTecnicoOptions}
                value={selectedCoord}
                onChange={async (e) => {
                  console.log(e)
                  if (!(e?.value)) {
                    setSelectedCoord(null)
                    if (!selectedProj) {
                      updateRows(products);
                      const selectProjetoOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1},
                        {"(SELECT proj_coord FROM proj AS p WHERE proj.proj_coord = p.proj_coord LIMIT 1)" : "proj_coord"});
                      setSelectFilterProjetoOptions(selectProjetoOptions);
                    } else {
                      const selectProjetoOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1},
                        {"(SELECT proj_coord FROM proj AS p WHERE proj.proj_coord = p.proj_coord LIMIT 1)" : "proj_coord"});
                      setSelectFilterProjetoOptions(selectProjetoOptions);
                      const filteredRowsByProj = filterArray(products, 'proj_id', selectedProj.value);
                      updateRows(filteredRowsByProj);
                    }
                  } else {
                    const selectProjetoOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1, proj_coord: e.value},
                      {"(SELECT proj_coord FROM proj AS p WHERE proj.proj_coord = p.proj_coord LIMIT 1)" : "proj_coord"});
                    setSelectFilterProjetoOptions(selectProjetoOptions);
                    if (!selectedProj) {
                      const filteredRows = filterArray(products, 'prod_responsavel', e.value)
                      updateRows(filteredRows)
                      setSelectedCoord(e)
                    } else {
                      const filteredRowsByProj = filterArray(products, 'proj_id', selectedProj.value)
                      const filteredRowsByCoord = filterArray(filteredRowsByProj, 'prod_responsavel', e.value)
                      updateRows(filteredRowsByCoord)
                      setSelectedCoord(e)
                    }
                  }
                }}
              />
            </Col>
            <Col>
            <label>Tipo de data:</label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                defaultValue={{label: 'Data Interna e Contratual', value: 'entrega-interna-contratual'}}
                options={[
                  {label: 'Data Interna', value: 'entrega-interna'},
                  {label: 'Data Contratual', value: 'entrega-contratual'},
                  {label: 'Data Interna e Contratual', value: 'entrega-interna-contratual'},
                ]}
                onChange={({ value }) => {
                  setFilterEntrega(value)
                }}
              />
            </Col>
            <Col>
              <label>Projeto:</label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectFilterProjetoOptions}
                onChange={async (e) => {
                  console.log(e)
                  if (!(e?.value)) {
                    setSelectedProj(null);
                    const selectCoordOptions = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1, dpto_id: 4},
                      {"(SELECT projAtuacao_id FROM projEquipe AS p WHERE pf.pf_id = p.pf_id AND projAtuacao_id = 8 LIMIT 1)" : "projAtuacao_id"});
                    const selectTecnicoCoordOptions = selectCoordOptions.filter(option => option.projAtuacao_id === 8);
                    setSelectFilterTecnicoOptions(selectTecnicoCoordOptions);
                    if (!selectedCoord) {
                      const selectCoordOptions = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1},
                        {"(SELECT projAtuacao_id FROM projEquipe AS p WHERE pf.pf_id = p.pf_id AND projAtuacao_id = 8 LIMIT 1)" : "projAtuacao_id"});
                      const selectTecnicoCoordOptions = selectCoordOptions.filter(option => option.projAtuacao_id === 8);
                      setSelectFilterTecnicoOptions(selectTecnicoCoordOptions);
                      updateRows(products);
                    } else {
                      const selectProjOptions = await selectValues('proj', 'proj_id', 'proj_nome', {proj_ativo: 1, proj_coord: selectedCoord.value},
                        {"(SELECT proj_coord FROM proj AS p WHERE proj.proj_coord = p.proj_coord LIMIT 1)" : "proj_coord"});
                      setSelectFilterProjetoOptions(selectProjOptions);
                      const filteredRowsByCoord = filterArray(products, 'prod_responsavel', selectedCoord.value);
                      updateRows(filteredRowsByCoord);
                    }
                  } else {
                    if (!selectedCoord) {
                      const selectCoordOptions = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1, pf_id: e.proj_coord},
                        {"(SELECT projAtuacao_id FROM projEquipe AS p WHERE pf.pf_id = p.pf_id AND projAtuacao_id = 8 LIMIT 1)" : "projAtuacao_id"});
                      const selectTecnicoCoordOptions = selectCoordOptions.filter(option => option.projAtuacao_id === 8);
                      setSelectFilterTecnicoOptions(selectTecnicoCoordOptions);
                      setSelectedCoord(selectTecnicoCoordOptions[0])
                      const filteredRows = filterArray(products, 'proj_id', e.value);
                      updateRows(filteredRows);
                      setSelectedProj(e);
                    } else {
                      const selectCoordOptions = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1, pf_id: e.proj_coord},
                        {"(SELECT projAtuacao_id FROM projEquipe AS p WHERE pf.pf_id = p.pf_id AND projAtuacao_id = 8 LIMIT 1)" : "projAtuacao_id"});
                      const selectTecnicoCoordOptions = selectCoordOptions.filter(option => option.projAtuacao_id === 8);
                      setSelectFilterTecnicoOptions(selectTecnicoCoordOptions);
                      setSelectedCoord(selectTecnicoCoordOptions[0]);
                      const filteredRowsByCoord = filterArray(products, 'prod_responsavel', e.proj_coord);
                      const filteredRowsByProj = filterArray(filteredRowsByCoord, 'proj_id', e.value);
                      updateRows(filteredRowsByProj);
                      setSelectedProj(e);
                    }
                  }
                }}
              />
            </Col>
          </div>
          {/*
          <Select
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            options={[
              {label: 'Janeiro', value: 1},
              {label: 'Fevereiro', value: 2},
              {label: 'Março', value: 3},
              {label: 'Abril', value: 4},
              {label: 'Maio', value: 5},
              {label: 'Junho', value: 6},
              {label: 'Julho', value: 7},
              {label: 'Agosto', value: 8},
              {label: 'Setembro', value: 9},
              {label: 'Outubro', value: 10},
              {label: 'Novembro', value: 11},
              {label: 'Dezembro', value: 12},
            ]}
            isMulti
            onChange={(e) => {
              if (e) {
                console.log(e);
              }
            }}
          />
          <Select
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            options={[
              {label: '2025', value: 2025},
              {label: '2026', value: 2026},
              {label: '2027', value: 2027},
            ]}
            isMulti
            onChange={(e) => {
            }}
          />
          */}
        </div>
        <div style={{marginTop: "32px"}}>
          <Legenda objLegenda={{"Data Contratual": "#ffbc5e", "Data Interna" : "lightgreen"}}/>
        </div>
        <div className='scroll-wrapper'>
          <div className="grid-container">
            <table className="calendar-table">
              <thead>
                {/* Month Row */}
                <tr className="month-row">
                  <th className="corner-cell"></th>
                  {Object.entries(objectToConsultProductsInSQL).map(([month, days], index) => (
                    <th
                      key={month}
                      colSpan={days.length}
                      className="month-cell"
                      style={{
                        backgroundColor: index % 2 === 0 ? '#e3e3e3' : '#d1d1d1',
                      }}
                    >
                      {month}
                    </th>
                  ))}
                </tr>
                {/* Days Row */}
                <tr className="days-row">
                  <th className="corner-cell"></th>
                  {Object.entries(objectToConsultProductsInSQL).map(([month, days], indexMonth) =>
                    days.map((day) => (
                      <th
                        key={`${month}-${day}`}
                        className="day-cell"
                        style={{
                          backgroundColor:
                            indexMonth % 2 === 0 ? '#e3e3e3' : '#d1d1d1',
                        }}
                      >
                        {day}
                      </th>
                    ))
                  )}
                </tr>
              </thead>
              <tbody>
                {/* Data Rows */}
                {!filteredProducts ?

                products.map((row, rowIndex) => {
                  const { month: monthInterna, day: dayInterna } = getDateParts(
                    row.prod_dtInterna || '2025-01-01'
                  );
                  const { month: monthContratual, day: dayContratual } =
                    getDateParts(row.prod_dtContrato || '2025-01-01');

                  return (
                    <tr key={rowIndex} className="data-row">
                      <th className="row-header-cell">{row.prod_desc}</th>
                      {Object.entries(objectToConsultProductsInSQL).map(([currentMonth, days]) =>
                        days.map((currentDay) => (
                          <td
                            key={`${currentMonth}-${currentDay}`}
                            className={`data-cell ${
                              currentMonth === monthInterna &&
                              currentDay === dayInterna &&
                              (filterEntrega === 'entrega-interna' ||
                                filterEntrega === 'entrega-interna-contratual')
                                ? 'entrega-interna'
                                : currentMonth === monthContratual &&
                                  currentDay === dayContratual &&
                                  (filterEntrega === 'entrega-contratual' ||
                                    filterEntrega === 'entrega-interna-contratual')
                                ? 'entrega-contratual'
                                : ''
                            }`}
                            onClick={() => {
                              setProductInfo(row);
                              handleOpenModal();
                            }}
                          >
                            {currentMonth === monthInterna &&
                            currentDay === dayInterna &&
                            row.prodEntregueAoClienteData
                              ? 'Entregue'
                              : ''}
                          </td>
                        ))
                      )}
                    </tr>
                  );
                })

                :

                filteredProducts.map((row, rowIndex) => {
                  const { month: monthInterna, day: dayInterna } = getDateParts(
                    row.prod_dtInterna || '2025-01-01'
                  );
                  const { month: monthContratual, day: dayContratual } =
                    getDateParts(row.prod_dtContrato || '2025-01-01');

                  return (
                    <tr key={rowIndex} className="data-row">
                      <th className="row-header-cell">{row.prod_desc}</th>
                      {Object.entries(objectToConsultProductsInSQL).map(([currentMonth, days]) =>
                        days.map((currentDay) => (
                          <td
                            key={`${currentMonth}-${currentDay}`}
                            className={`data-cell ${
                              currentMonth === monthInterna &&
                              currentDay === dayInterna &&
                              (filterEntrega === 'entrega-interna' ||
                                filterEntrega === 'entrega-interna-contratual')
                                ? 'entrega-interna'
                                : currentMonth === monthContratual &&
                                  currentDay === dayContratual &&
                                  (filterEntrega === 'entrega-contratual' ||
                                    filterEntrega === 'entrega-interna-contratual')
                                ? 'entrega-contratual'
                                : ''
                            }`}
                            onClick={() => {
                              setProductInfo(row);
                              handleOpenModal();
                            }}
                          >
                            {currentMonth === monthInterna &&
                            currentDay === dayInterna &&
                            row.prodEntregueAoClienteData
                              ? 'Entregue'
                              : ''}
                          </td>
                        ))
                      )}
                    </tr>
                  );
                })
              }
              </tbody>
            </table>
          </div>
        </div>
        <Modal
          open={isModalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Resumo do produto
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <p>Produto: {productInfo.prod_desc}</p><br/>
              <p>Projeto: {productInfo.proj_nome}</p><br/>
              <p>Responsável: {productInfo.prod_responsavelNome ?? productInfo.prod_responsavelNomeAtual}</p><br/>
            </Typography>
            <Button onClick={handleCloseModal}>Voltar</Button>
          </Box>
        </Modal>
      </>
    );
  }
};

export default GridProductsCalendar;
